import cx from 'classnames';
import { useContext } from 'react';
import { Paragraph } from '@/home/HeroCardsReturnUser/Cards/styles';
import TradeImage from '@/home/HeroCardsReturnUser/Cards/TradeImage';
import useGetTradeInStatus from '~/components/home/hooks/useGetTradeStatus';
import TradeContext from '~/context/common/TradeContext';
import { nativeStcPayload } from '~/native/home/utils';
import { activeTradeStatuses, TradeStatus } from './constants';
import { DetailsWrapper, TradeValue, YearMakeModel } from './Details.styles';

type OwnProps = {
  ctaText: string;
};

export default function Details({ ctaText }: OwnProps) {
  const tradeStatus = useGetTradeInStatus();
  const hasTrade = tradeStatus !== TradeStatus.None;
  const { statusAgnosticTrade } = useContext(TradeContext);
  const {
    daysToExpiration = 0,
    id = '',
    vehicle: { make = '', model = '', year = 0 } = {},
    offerAmount = 0
  } = statusAgnosticTrade ?? {};
  const yearMakeModel = `${year} ${make} ${model}`;
  const showTradeValue = Boolean(activeTradeStatuses[tradeStatus]);

  return hasTrade ? (
    <div
      className={cx('flex flex-col gap-16 m:flex-row', {
        'row-span-2 m:col-span-2': hasTrade
      })}
    >
      <TradeImage consumer="experiment" />

      <DetailsWrapper
        data-qa="trade-details-wrapper"
        showValue={showTradeValue}
      >
        <YearMakeModel showValue={showTradeValue} title={yearMakeModel}>
          {yearMakeModel}
        </YearMakeModel>

        <div className={cx({ hidden: !showTradeValue })}>
          <span className="tl-body-m">Your Carvana Offer:</span>

          <div className="flex flex-row justify-between">
            <TradeValue data-qa="trade-card-value">
              ${offerAmount.toLocaleString()}
            </TradeValue>
            <a
              className="self-end capitalize text-blue-6 tl-link-s"
              data-analytics-id="Home feed card"
              data-analytics-attributes={JSON.stringify({
                description: 'STC card',
                expireDays: daysToExpiration,
                status: tradeStatus,
                cta: ctaText,
                item: 'view details'
              })}
              data-qa="Trade view offer details link"
              data-native-payload={nativeStcPayload}
              href={`/sell-my-car/hub/${id}`}
            >
              view details
            </a>
          </div>
        </div>
      </DetailsWrapper>
    </div>
  ) : (
    <Paragraph data-qa="no-trade-paragraph">
      You decide to sell, trade, or track your value
    </Paragraph>
  );
}
